import { Record } from 'immutable';
import isValidJson from '../../util/isValidJson';

const stockJobConfig = {
  fromFile: false,
  unloadInfo: {
    query: 'select 123',
    delimiter: ',',
  },
};

class JobTaskSpec extends Record(
  {
    taskIndex: null,
    name: '',
    jobType: '',
    config: '{}',
  }) {

  get toGiraffe() {
    return {
      name: this.name,
      jobType: this.jobType,
      config: JSON.parse(this.config || '{}'),
    };
  }

  get displayConfig() {
    return this.config;
  }

  static stockTask = () => (
    new JobTaskSpec({
      jobType: 'sql_runner',
      config: JSON.stringify(stockJobConfig, null, 4),
    })
  );

  get label() {
    return this.name || this.jobType || `Step ${this.taskIndex + 1}`;
  }


  get valid() {
    return this._validJobType && this._validConfig; // name is optional
  }

  get _validJobType() {
    return !!this.jobType && this.jobType !== '-1';
  }

  get _validConfig() {
    return isValidJson(this.config || '{}');
  }
}

export default JobTaskSpec;
